import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/POLIOL_I_50x50.webp")